import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-filter-taille',
  templateUrl: './filter-taille.component.html',
  styleUrls: ['./filter-taille.component.css']
})
export class FilterTailleComponent implements OnInit {

  btnAffichage = 'normal';
  @Input() defaultselected;

  @Output() selectfunction = new EventEmitter<String>();
  constructor() { }

  ngOnInit() {
    // console.log(this.defaultselected);
    if (this.defaultselected) {
      this.btnAffichage = this.defaultselected;
      // this.selectAffichage(this.defaultselected);
    }
  }

  selectAffichage(event) {
    this.btnAffichage = event;
    this.selectfunction.emit(event);
  }
}
